import React, { forwardRef, ForwardedRef } from 'react';
import { useHover } from 'react-aria/useHover';
import { filterDOMProps } from 'react-aria/filterDOMProps';
import { AriaLabelingProps } from '@react-types/shared';

import { useListItemContext } from './ListItemContext';
import {
  SapphireStyleProps,
  useSapphireStyleProps,
  useThemeCheck,
} from '../../utils';
import { AriaLabelingPropsKeys, GlobalDomAttributes } from '../../utils/types';

export interface ListItemButtonGroupProps
  extends Pick<AriaLabelingProps, AriaLabelingPropsKeys>,
    SapphireStyleProps,
    GlobalDomAttributes {
  children: React.ReactNode;
}

/**
 * ListItemButton ensures that list item loses background style when the Button is hovered.
 * Any button used in list item should be wrapped with this component.
 *
 * @deprecated Will be removed in the next major version
 */
export const ListItemButton = forwardRef(function ListItemButton(
  props: ListItemButtonGroupProps,
  ref: ForwardedRef<HTMLSpanElement>
) {
  const { setActionButtonHovered } = useListItemContext();
  useThemeCheck();

  const { children, ...otherProps } = props;
  const { styleProps } = useSapphireStyleProps(otherProps);
  const { hoverProps: actionIconHoverProps } = useHover({
    onHoverChange: setActionButtonHovered,
  });

  return (
    <>
      <span
        ref={ref}
        {...filterDOMProps(props, { global: true })}
        className={styleProps.className}
        style={styleProps.style}
        {...actionIconHoverProps}
        {...{
          onClick: (e) => {
            e.stopPropagation();
          },
        }}
      >
        {children}
      </span>
    </>
  );
});
